module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"errorCode":"Errore 404","errorMessage":"Ops, qualcosa è andato storto.","actionText":"Torna alla home"},"en":{"errorCode":"Error 404","errorMessage":"Ops, something went wrong.","actionText":"Back to home"}}')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/app/common/page404.vue
// module id = 133
// module chunks = 0